import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';
import { Input } from 'antd';
import { selectFieldValueI18n } from '@icp/form-renderer-core';
import { composeEvent } from '@icp/utils';
import { useSelector } from '../../../store';

function I18nInputSingle(props) {
  const {
    id,
    languageOp,
    value: valueProp,
    changeDelayToBlur,
    onChange,
    onBlur,
    onKeyDown,
    onKeyUp,
    ...other
    //
  } = props;

  const valueI18n = useSelector(selectFieldValueI18n(id, languageOp.value));
  const [value, setValue] = useState(valueI18n);
  // 让 keydown 和 keyup 之间 onChange 只会触发一次，防止一致按住 Enter 键反复触发 onChange
  const once = useRef(false);

  useEffect(() => {
    setValue(valueI18n);
  }, [valueI18n]);

  const handleChange = (event) => {
    setValue(event.target.value);
    if (!changeDelayToBlur) {
      onChange(event.target.value, languageOp.value);
    }
  };

  const handleBlur = (event) => {
    if (changeDelayToBlur) {
      onChange(event.target.value, languageOp.value);
    }
  };

  // 当 changeDelayToBlur 时，按回车键也需要触发 onChange。和原生 input 逻辑一致
  const handleKeyDown = (event) => {
    if (!changeDelayToBlur) {
      return;
    }

    if (once.current) {
      return;
    }

    if (event.key === 'Enter') {
      once.current = true;
      onChange(value, languageOp.value);
    }
  };

  const handleKeyUp = (event) => {
    if (!changeDelayToBlur) {
      return;
    }

    if (event.key === 'Enter') {
      once.current = false;
    }
  };

  return (
    <Input
      autoComplete="off"
      {...other}
      value={value ?? ''}
      onChange={handleChange}
      onBlur={composeEvent(handleBlur, onBlur)}
      onKeyDown={composeEvent(handleKeyDown, onKeyDown)}
      onKeyUp={composeEvent(handleKeyUp, onKeyUp)}
      addonBefore={languageOp.label}
    />
  );
}

I18nInputSingle.propTypes = {
  id: PropTypes.string,
  languageOp: PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  }),
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  changeDelayToBlur: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyDown: PropTypes.func,
  onKeyUp: PropTypes.func,
};

export default I18nInputSingle;
